import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ALL_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllFrontlineCoachesContent} from './AllFrontlineCoachesContent';
import {AllFrontlineCoachesContentProps} from './AllFrontlineCoachesContent.types';
import reportPayload from './reportPayload';

export const AllFrontlineCoachesReport = ({
  loadingData = {total: 0}, // Default value for loadingData
  tt = (key: string, defaultValue?: string) => defaultValue || '', // Default translation function
  showRecordPopover = () => {}, // No-op function
}: AllFrontlineCoachesContentProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Frontline Coaches')}
      description={tt(
        'description',
        'All of your Frontline Coaches (personally sponsored by you).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllFrontlineCoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allFrontlineCoaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ALL_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.allFrontLine',
          'All Frontline Coaches',
        ),
    },
  }),
)(AllFrontlineCoachesReport);
